import { render } from "./LoginFormMfa.vue?vue&type=template&id=b2727e98&scoped=true"
import script from "./LoginFormMfa.vue?vue&type=script&lang=js"
export * from "./LoginFormMfa.vue?vue&type=script&lang=js"

import "./LoginFormMfa.vue?vue&type=style&index=0&id=b2727e98&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2727e98"]])

export default __exports__